import { Component, OnInit } from '@angular/core';
import { BaseComponent } from "../base/base.component";
import { RestClient } from '../rest-client.service';
import { BsaProfileInfoXBVO } from '../model/xbvo.model';
import { ConfirmationService } from 'primeng/api';
import { NgModel } from '@angular/forms';
import { StringUtils } from '../base/utils/string.utils';

/**
 * App-Component
 */
@Component({
  selector: '<skitbs-terminate>',
  templateUrl: './contractTermination.component.html'
})
export class ContractTerminationComponent extends BaseComponent implements OnInit {
  modelXBVO: BsaProfileInfoXBVO;
  calendarDate: Date;
  ibanNR: string | undefined;
  isContractTerminated: String;

  /**
   * Constructor.
   * @param router
   * @param restClient
   * @param confirmationService
   */
  constructor(private restClient: RestClient, private confirmationService: ConfirmationService) {
    super();
  }

  ngOnInit(): void {
    this.restClient.profileInfo().subscribe((aXBVO => {
      this.modelXBVO = aXBVO;
      this.ibanNR = StringUtils.maskAsterisk(aXBVO.sepaIBAN);
      this.isContractTerminated = aXBVO.terminationState
    }));
  }

  setTerminationRequest() {
    this.confirmationService.confirm({
      message: this.v('pleaseConfirm') + ". " + this.v('terminationDate') + ": " + this.calendarDate,
      accept: () => {
        this.restClient
          .setTerminationRequest(true, this.calendarDate, this.modelXBVO.sepaIBAN).subscribe(aResponse => {
            this.ibanNR = StringUtils.maskAsterisk(this.modelXBVO.sepaIBAN);
            this.toastInfo(this.v("operationComplete"));
          });
      }
    });
  }

  onIbanFocus(ngModel: NgModel){
      if (!ngModel.dirty) this.ibanNR = '';
  }

  onIbanFocusOut(ngModel: NgModel){
      if (!ngModel.dirty) this.ibanNR = StringUtils.maskAsterisk(this.modelXBVO.sepaIBAN);
  }

onIbanChanged(ngModel: NgModel) {

    if (!this.modelXBVO.sepaActive && this.ibanNR === "") {
      this.modelXBVO.sepaIBAN = null;
      return;
    }

    
    if (this.ibanNR !== "") {
      this.restClient.callValidateIBAN(this.ibanNR).subscribe({
        next: x => this.modelXBVO.sepaIBAN = this.ibanNR,
        error: err => ngModel.control.setErrors({
          ibanValidatorMessage: this.i18n.v("invalidIBAN"),
        })
      });
    }
  }

  canTerminate(): boolean {
    return !(!this.calendarDate);
  }

}
